var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 165.865,
    height: 176.169,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1079.51 1146.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#698a9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#afcfde"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#6c8fa5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d0e7f3"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#cdd4d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#e3edf1"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#263852"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d0e7f3"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id4",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#253145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#89b5c9"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id5",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#262f42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#78abc2"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id6",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#6c8fa5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d4e9f3"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id7",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#243c57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#fefefe"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id8",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#cdd4d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#e7eff3"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id9",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#6c91a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#e5f2f6"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id3",
    id: "id10",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id7",
    id: "id11",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id9",
    id: "id12",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id13",
    x1: 531.98,
    x2: 531.98,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#1e1f22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#243042"
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id13",
    id: "id14",
    x1: 531.98,
    x2: 531.98,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id7",
    id: "id15",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id9",
    id: "id16",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id17",
    x1: 532.47,
    x2: 532.47,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#cdd8de"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#fefefe"
    }
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id3",
    id: "id18",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id7",
    id: "id19",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id8",
    id: "id20",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id1",
    id: "id21",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id8",
    id: "id22",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id23",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#253952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d4eaf4"
    }
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#id9",
    id: "id24",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id25",
    x1: 532.23,
    x2: 532.23,
    y1: 1029.14,
    y2: 787.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#253952"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d9ecf4"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fil10,.fil6,.fil9{fill:#008468;fill-rule:nonzero}.fil6,.fil9{fill:#00957d}.fil6{fill:#009d87}.fil4,.fil43,.fil8{fill:#00a99e;fill-rule:nonzero}.fil4,.fil43{fill:#06aeaa}.fil43{fill:#1b7899}.fil16,.fil19,.fil24{fill:#1c435c;fill-rule:nonzero}.fil16,.fil24{fill:#243042}.fil24{fill:#243c57}.fil20,.fil3,.fil5{fill:#4a71f3;fill-rule:nonzero}.fil20,.fil5{fill:#89b5c9}.fil5{fill:#95c4df}.fil15,.fil23,.fil57{fill:#a6c9d9;fill-rule:nonzero}.fil15,.fil57{fill:#b1d8e9}.fil57{fill:#c0dbeb}.fil1,.fil11,.fil17{fill:#d0e7f3;fill-rule:nonzero}.fil1,.fil11{fill:#d9ecf4}.fil1{fill:#e5f2f6}.fil2,.fil21,.fil22{fill:#f29789;fill-rule:nonzero}.fil2,.fil22{fill:#f4a89c}.fil2{fill:#fefefe}"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1356234059552"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.88 1084.68c38.82-31.01 76.36-66.07 111.14-103.76h1.42v-1.42c26.12-28.46 50.67-58.34 73.1-89.13.35.07.57.14.57.14l.35-1.42c20.44-28.25 39.03-57.2 55.28-86.44 3.26-5.82 7.17-13.63 11.43-22.78.21 0 .28.07.35.07l.28-1.42c5.61-12.28 11.71-26.9 17.17-42.51.99 10.15 1.49 20.44 1.49 30.8 0 160.95-118.16 294.23-272.45 317.94l-.14-.07z",
    style: {
      fill: "#ddedf4",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M774.62 687.54V446.75c94.67 9.94 177.14 60.96 229.23 134.91-7.24 1.99-14.34 4.75-21.15 7.95l-.35.21c-10.43 4.97-20.01 10.93-27.75 16.54-16.61 12.13-31.79 27.11-45.63 43.72l-1.42.35c0 .07.07.43.21 1.06-9.22 11.21-17.81 23.21-25.76 35.56-.64-3.19-1.28-6.17-1.99-9.02v-.21h-.07c-.14-.71-.35-1.42-.57-2.13-4.69-22.78-14.98-40.59-35.2-43.15l-.92-.35s-.07.14-.07.21c-.92-.07-1.92-.14-2.84-.14-12.85 0-25.76 7.66-36.34 16.96l-.14.07c-5.89 5.18-11.07 10.86-15.05 16.04-5.32 6.88-10.08 14.33-14.34 22.21h.14zM249.1 692.01c-6.25-17.88-13.2-35.48-21.22-52.59l.43-.64-1.14-.85c-6.96-14.76-14.69-29.17-23.35-43.08-7.74-12.49-18.17-27.61-30.73-39.6l.07-.07-1.14-.92c-12.21-11.36-26.33-19.66-42.09-19.66-.92 0-1.91 0-2.84.07-4.68.28-9.01 1.21-12.99 2.62l-1.35.29s0 .14.07.21c-28.67 11.36-40.73 49.96-44.5 80.9l-.21 1.28h.07c-.57 5.18-.92 10.08-1.14 14.62-.5 14.69.21 29.59 2.06 44.64C27.16 648.43-.02 598.82-.02 542.76c0-93.39 75.72-169.19 169.19-169.19 49.25 0 93.61 21.08 124.48 54.65v91.62c-5.96 21.01-11.99 44.36-16.54 66.29-4.19 20.51-9.72 57.91-15.19 98.01A157.75 157.75 0 0 1 249 691.8l.07.21zM801.87 241.43c-9.37 0-18.52-1.14-27.25-3.26v-55.99c1.42-.35 2.27-.78 2.27-.78s2.2 5.6 8.44 6.39c1.7.21 3.41.29 5.11.29 21.43 0 42.3-16.47 49.32-37.62 8.02-23.85.28-48.97-27.89-48.97-2.48 0-5.11.21-7.88.57.14-.71.35-1.49.5-2.2.21-.85.28-1.7.5-2.63.14-.85.35-1.77.35-2.62.07-.78.14-1.49.21-2.2 2.41.85 9.58 3.19 18.03 3.19 4.61 0 9.58-.71 14.26-2.7 15.33-6.53 22.28-24.49 22.28-24.49s-8.52-3.48-18.81-3.48c-4.61 0-9.58.71-14.26 2.7-12.21 5.18-19.09 17.6-21.43 22.5v-.43c0-.78 0-1.49-.07-2.27-.07-.71-.07-1.42-.07-2.06 0-.57-.07-1.06-.07-1.42 0-.78.07-1.28.07-1.28.14-.92-.14-1.84-.92-2.56-.57-.49-1.28-.78-1.92-.78-.78 0-1.56.29-2.13.92-1.06 1.14-.99 2.98.14 4.05 0 0 .35.35.85.92.21.28.57.71.78 1.14.21.43.35.92.57 1.49.21.57.29 1.21.35 1.92.07.71.21 1.49.21 2.27s0 1.63.07 2.41c.07.85-.07 1.7-.14 2.56-.07.85-.07 1.7-.29 2.56-.07.57-.21 1.13-.28 1.7-7.1-8.02-15.19-11.5-22.99-11.5-14.76 0-28.67 12.21-34.35 29.03-3.34 9.86-3.55 20.58-1.14 30.59h-55c-1.49-7.38-2.27-15.04-2.27-22.85 0-63.45 51.45-114.9 114.9-114.9 63.44 0 114.9 51.45 114.9 114.9s-51.45 114.9-114.9 114.9h-.07z",
    className: "fil1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M944.59 461.79c-28.18 54.01-94.81 74.87-148.82 46.7-54.01-28.17-74.87-94.81-46.7-148.82 28.17-54.01 94.81-74.87 148.82-46.7 54.01 28.18 74.87 94.81 46.7 148.82z",
    className: "fil2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m904.28 327.16-21.72-11.35 8.95-17.04 21.71 11.36z",
    className: "fil2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M922.66 314.74c-1.42 2.7-4.75 3.76-7.45 2.34l-30.59-15.97c-2.7-1.42-3.76-4.75-2.34-7.45l3.83-7.31c1.42-2.7 4.75-3.76 7.45-2.34l30.59 15.97c2.7 1.42 3.76 4.75 2.34 7.45l-3.83 7.31zM952.4 389.83l-5.54-17.89 13.98-4.4 5.61 17.89z",
    className: "fil2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M970.28 392.6c-2.91.92-6.03-.71-6.88-3.62l-7.1-22.57c-.92-2.91.71-6.03 3.62-6.89l3.48-1.06c2.91-.92 6.03.71 6.88 3.62l7.1 22.57c.92 2.91-.71 6.03-3.62 6.89l-3.48 1.06z",
    className: "fil2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M923.87 451c-22.21 42.58-74.73 59.05-117.24 36.76-42.51-22.21-59.05-74.73-36.76-117.31 22.21-42.58 74.73-59.04 117.24-36.76 42.58 22.21 59.05 74.73 36.76 117.31z",
    className: "fil3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M860.71 418c-3.98 7.66-13.48 10.65-21.15 6.67-7.66-4.05-10.64-13.48-6.67-21.15 4.05-7.66 13.48-10.65 21.15-6.67 7.66 4.04 10.65 13.48 6.67 21.15z",
    className: "fil2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M846.23 411.9c-.64-.35-.92-1.14-.57-1.77l32.93-63.02c.35-.64 1.14-.92 1.77-.57.64.35.92 1.14.57 1.77L848 411.33c-.35.64-1.13.92-1.77.57zM882.07 343.2c-.64-.35-.92-1.14-.57-1.77l1.99-3.76c.35-.64 1.14-.92 1.77-.57.64.35.92 1.14.57 1.77l-1.99 3.76c-.35.64-1.14.92-1.77.57zM808.55 484c-.64-.35-.92-1.14-.57-1.77l1.99-3.76c.35-.64 1.14-.92 1.77-.57.64.35.92 1.14.57 1.77l-1.99 3.76c-.35.64-1.14.92-1.77.57zM869.86 338.09c-.71-.21-1.07-.99-.85-1.63l1.28-4.04c.21-.71.92-1.07 1.63-.85.71.21 1.07.92.85 1.63l-1.28 4.05c-.21.71-.92 1.06-1.63.85zM821.89 489.54c-.71-.21-1.07-.92-.85-1.63l1.28-4.04c.21-.71.92-1.07 1.63-.85.71.21 1.06.92.85 1.63l-1.28 4.04c-.21.71-.99 1.07-1.63.85zM856.94 335.18c-.71-.07-1.21-.78-1.14-1.49l.57-4.26c.07-.71.78-1.21 1.49-1.14.71.07 1.21.78 1.13 1.49l-.57 4.26c-.07.71-.78 1.21-1.49 1.13zM836.01 492.73c-.71-.07-1.21-.78-1.14-1.49l.57-4.26c.07-.71.78-1.21 1.49-1.14.71.07 1.21.78 1.14 1.49l-.57 4.26c-.07.71-.78 1.21-1.49 1.13zM843.75 334.61c-.71 0-1.35-.5-1.35-1.28l-.21-4.26c0-.71.5-1.35 1.28-1.35.71 0 1.35.5 1.35 1.28l.21 4.26c0 .71-.57 1.35-1.28 1.35zM850.42 493.37c-.71 0-1.35-.57-1.35-1.28l-.21-4.26c0-.71.57-1.35 1.28-1.35.71 0 1.35.5 1.35 1.28l.21 4.26c0 .71-.57 1.35-1.28 1.35zM830.55 336.32c-.71.14-1.42-.28-1.56-.99l-.92-4.19c-.14-.71.28-1.42.99-1.56.71-.14 1.42.28 1.56.99l.92 4.19c.14.71-.29 1.42-.99 1.56zM864.75 491.45c-.71.14-1.42-.28-1.56-.99l-.92-4.19c-.14-.71.28-1.42.99-1.56.71-.14 1.42.28 1.56.99l.92 4.19c.14.71-.29 1.42-.99 1.56zM817.91 340.29c-.64.29-1.42-.07-1.7-.71l-1.63-3.98c-.28-.71.07-1.42.71-1.7.64-.29 1.42.07 1.7.71l1.63 3.98c.28.64 0 1.42-.71 1.7zM878.52 487.12c-.64.28-1.42-.07-1.7-.71l-1.63-3.98c-.28-.64.07-1.42.71-1.7.64-.28 1.42.07 1.7.71l1.63 3.98c.28.64-.07 1.42-.71 1.7zM806.2 346.39c-.64.35-1.42.21-1.77-.43l-2.27-3.62c-.43-.64-.21-1.42.43-1.84.64-.35 1.42-.21 1.84.43l2.27 3.62c.43.64.21 1.42-.43 1.84h-.07zM891.37 480.53c-.64.35-1.42.21-1.77-.43l-2.27-3.62c-.43-.64-.21-1.42.43-1.85.64-.43 1.42-.21 1.77.43l2.27 3.62c.35.64.21 1.42-.43 1.84zM795.63 354.41c-.5.5-1.35.43-1.85-.07l-2.91-3.12c-.5-.5-.43-1.35.07-1.84.5-.5 1.35-.43 1.85.07l2.91 3.12c.5.57.43 1.35-.07 1.84zM902.86 471.73c-.57.49-1.35.43-1.84-.07l-2.91-3.12c-.5-.57-.43-1.35.07-1.85s1.35-.43 1.84.07l2.91 3.12c.5.57.43 1.35-.07 1.85zM786.69 364.21c-.43.57-1.28.64-1.84.21l-3.41-2.62c-.57-.43-.71-1.28-.21-1.84.43-.57 1.28-.71 1.85-.21l3.4 2.62c.57.43.71 1.28.21 1.85zM912.58 461.08c-.43.57-1.28.71-1.84.21l-3.34-2.62c-.57-.43-.71-1.28-.28-1.84.43-.57 1.28-.71 1.84-.21l3.41 2.62c.57.43.71 1.28.21 1.85zM779.59 375.35c-.35.64-1.14.85-1.77.57l-3.76-1.99c-.64-.35-.92-1.14-.57-1.77.35-.64 1.14-.92 1.77-.57l3.76 1.99c.64.35.92 1.14.57 1.77zM920.39 448.87c-.35.64-1.14.92-1.77.57l-3.76-1.99c-.64-.35-.92-1.13-.57-1.77.35-.64 1.14-.92 1.77-.57l3.76 1.99c.64.35.92 1.14.57 1.77zM774.48 387.56c-.21.71-.99 1.07-1.63.85l-4.05-1.28c-.71-.21-1.06-.92-.85-1.63.21-.71.99-1.07 1.63-.85l4.04 1.28c.71.21 1.07.92.85 1.63zM925.93 435.53c-.21.71-.92 1.07-1.63.85l-4.05-1.28c-.71-.21-1.06-.92-.85-1.63.21-.71.92-1.06 1.63-.85l4.05 1.28c.71.21 1.06.99.85 1.63zM771.57 400.47c-.07.71-.78 1.21-1.49 1.14l-4.26-.57c-.71-.07-1.21-.78-1.14-1.49.07-.71.78-1.21 1.49-1.13l4.26.57c.71.07 1.21.78 1.14 1.49zM929.05 421.48c-.07.71-.71 1.21-1.49 1.14l-4.26-.57c-.71-.07-1.21-.78-1.14-1.49.07-.71.78-1.21 1.49-1.13l4.26.57c.71.07 1.21.78 1.14 1.49zM771 413.74c.07.71-.5 1.35-1.28 1.35l-4.26.21c-.71 0-1.35-.5-1.35-1.28 0-.71.5-1.35 1.28-1.35l4.26-.21c.71 0 1.35.5 1.35 1.28zM929.76 407c0 .71-.5 1.35-1.28 1.35l-4.26.21c-.71 0-1.35-.5-1.35-1.28-.07-.71.5-1.35 1.28-1.35l4.26-.21c.71-.07 1.35.49 1.35 1.28zM772.71 426.87c.14.71-.28 1.42-.99 1.56l-4.19.92c-.71.14-1.42-.28-1.56-.99-.14-.71.28-1.42.99-1.56l4.19-.92c.71-.14 1.42.28 1.56.99zM927.84 392.74c.14.71-.28 1.42-.99 1.56l-4.19.92c-.71.14-1.42-.29-1.56-.99-.14-.71.28-1.42.99-1.56l4.19-.92c.71-.14 1.42.28 1.56.99zM776.68 439.5c.28.64-.07 1.42-.71 1.7l-3.98 1.63c-.64.29-1.42-.07-1.7-.71-.28-.64.07-1.42.71-1.7l3.98-1.63c.64-.29 1.42.07 1.7.71zM923.51 378.9c.29.64-.07 1.42-.71 1.7l-3.9 1.63c-.64.28-1.42-.07-1.7-.71-.28-.64.07-1.42.71-1.7l3.98-1.63c.71-.28 1.42.07 1.7.71h-.07zM782.78 451.29c.43.64.21 1.42-.43 1.77l-3.62 2.27c-.64.43-1.42.21-1.85-.43-.43-.64-.21-1.42.43-1.85l3.62-2.27c.64-.35 1.42-.21 1.77.43l.07.07zM916.91 366.13c.35.64.21 1.42-.43 1.84l-3.62 2.27c-.64.35-1.42.21-1.84-.43-.43-.64-.21-1.42.43-1.84l3.62-2.27c.64-.43 1.42-.21 1.77.43h.07zM790.8 461.79c.5.57.43 1.35-.07 1.85l-3.12 2.91c-.5.5-1.35.43-1.84-.07-.5-.57-.43-1.35.07-1.85l3.12-2.91c.57-.5 1.35-.43 1.84.07zM908.11 354.63c.5.5.43 1.35-.07 1.84l-3.12 2.91c-.57.5-1.35.43-1.84-.07-.5-.57-.43-1.35.07-1.84l3.12-2.91c.57-.5 1.35-.43 1.84.07zM800.59 470.73c.57.43.64 1.28.21 1.84l-2.62 3.41c-.43.57-1.28.71-1.85.21-.57-.43-.71-1.28-.21-1.84l2.62-3.41c.43-.57 1.28-.71 1.84-.21zM897.47 344.83c.57.43.71 1.28.21 1.84l-2.63 3.41c-.43.57-1.28.71-1.84.21-.57-.43-.71-1.28-.21-1.84l2.63-3.41c.43-.57 1.28-.71 1.84-.21zM804 102.12c.14-.71.35-1.49.5-2.2.21-.85.28-1.7.5-2.63.14-.85.35-1.77.35-2.62.07-.78.14-1.49.21-2.2 3.69 1.35 18.95 6.17 32.29.5 15.33-6.53 22.28-24.49 22.28-24.49s-17.81-7.31-33.14-.78c-12.21 5.18-19.09 17.6-21.43 22.5v-.43c0-.78 0-1.49-.07-2.27-.07-.71-.07-1.42-.07-2.06 0-.57-.07-1.06-.07-1.42 0-.78.07-1.28.07-1.28.14-.92-.14-1.84-.92-2.56-1.13-1.06-2.98-.99-4.04.14-1.07 1.14-.99 2.98.14 4.05 0 0 .35.35.85.92.21.28.57.71.78 1.14.21.43.35.92.57 1.49.21.57.28 1.21.35 1.92.07.71.21 1.49.21 2.27s0 1.63.07 2.41c.07.85-.07 1.7-.14 2.56-.07.85-.07 1.7-.28 2.56-.07.57-.21 1.13-.28 1.7-20.51-23.13-48.69-8.23-57.34 17.53-7.45 22.14.64 48.61 19.23 61.46 6.25 4.33 12.28 1.14 12.28 1.14s2.2 5.61 8.44 6.39c23.14 2.91 46.77-14.48 54.43-37.33 8.73-25.9-1.21-53.37-35.77-48.4zM200.27 448.23c-.21-.57-.43-1.14-.64-1.77-.28-.64-.43-1.35-.57-2.06-.14-.71-.43-1.42-.5-2.13-.14-.64-.21-1.21-.35-1.77-2.91 1.42-14.9 6.67-26.33 3.12-13.06-4.04-20.3-18.1-20.3-18.1s13.91-7.52 26.97-3.48c10.36 3.19 17.11 12.77 19.37 16.54v-.35c-.07-.64-.14-1.21-.14-1.84 0-.57-.07-1.14-.14-1.7 0-.5 0-.85-.07-1.21-.07-.64-.14-1.06-.14-1.06-.21-.71 0-1.56.5-2.13.85-.99 2.34-1.06 3.34-.21.99.85 1.06 2.34.21 3.34 0 0-.28.29-.57.85-.14.28-.43.64-.5.99-.14.35-.21.78-.35 1.21-.14.43-.14.99-.14 1.63 0 .57-.07 1.21 0 1.84.07.64.07 1.35.14 1.99.07.71.21 1.35.35 2.06.14.71.21 1.42.43 2.06.14.5.29.92.43 1.42 14.83-20.65 39.03-10.86 48.33 9.44 7.95 17.46 3.55 39.74-10.5 51.81-4.75 4.05-9.94 1.92-9.94 1.92s-1.35 4.75-6.31 5.96c-18.67 4.33-39.39-7.88-47.55-25.83-9.3-20.44-3.55-43.64 25.12-42.51h-.14zM221.21 242.85a8.845 8.845 0 0 0-11.14 5.75l2.7-8.52c1.92-6.03-1.42-12.42-7.38-14.34-6.03-1.92-12.42 1.42-14.34 7.38l-9.44 29.59-73.24-23.35 9.44-29.59c1.92-6.03-1.42-12.42-7.38-14.33-6.03-1.92-12.42 1.42-14.34 7.38l-2.7 8.52a8.837 8.837 0 0 0-5.75-11.14 8.837 8.837 0 0 0-11.14 5.75L57.69 265a8.833 8.833 0 0 0 5.75 11.14 8.837 8.837 0 0 0 11.14-5.75l-2.7 8.52c-1.92 6.03 1.42 12.42 7.38 14.34 6.03 1.92 12.42-1.42 14.34-7.38l9.44-29.59 73.24 23.35-9.44 29.59c-1.92 6.03 1.42 12.42 7.38 14.34 6.03 1.92 12.42-1.42 14.34-7.38l2.7-8.52a8.837 8.837 0 0 0 5.75 11.14 8.845 8.845 0 0 0 11.14-5.75L226.96 254a8.837 8.837 0 0 0-5.75-11.14z",
    className: "fil2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M316.24 1118.39c-21.93-5.75-49.89-20.23-74.02-31.58-50.17-23.56-98.64-53.51-142.43-87.43-31.44-24.34-63.73-58.69-78.56-96.38-7.1-18.1-13.06-47.48.14-64.44 32.08-41.09 117.67 24.91 141.51 47.83 64.72 62.17 120.43 147.62 153.36 231.92v.07z",
    className: "fil4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.6 1062.26c-1.42-.14-2.06-.21-2.13-.21l.07-.99c.71.43 1.42.78 2.06 1.21zm-81.05-51.52-.07-.99c.43.28.85.64 1.28.92h-1.21v.07zm-70.9-69.34h-.71v-.99c.21.35.5.64.71.99zm-27.54-59.47-.07-.21c0 .07 0 .14.07.21zm5.61-42.51a.866.866 0 0 0-.14-.21l.78-.64c-.21.28-.43.57-.64.78v.07zm58.62-7.88c-.28-.14-.64-.21-.92-.35.07-.07.07-.14.07-.14l.85.5z",
    className: "fil5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M293.67 1104.48c-11.21-7.81-22.36-16.04-33.43-24.56-37.61-13.69-59.19-16.96-65.72-17.67-.71-.43-1.42-.78-2.06-1.21l.07-.99c.21 0 20.72 1.21 62.81 16.04-18.81-14.69-37.12-30.23-54.79-46.06-48.47-18.17-78.42-19.37-85.45-19.37h-.35c-.43-.28-.85-.64-1.28-.92l-.07-.99h1.63c6.88 0 35.48 1.14 81.68 17.81-22.64-20.44-44-41.16-63.59-61.1l-.14-.07c-46.77-21.36-84.67-23.78-90.34-23.99-.21-.35-.5-.64-.71-.99v-.99c.43 0 38.68.92 87.5 22.21-25.69-26.26-48.05-50.96-65.79-71.18-16.96-6.25-30.52-7.52-38.89-7.52-5.89 0-9.23.64-9.3.64l-.35-1.7c0-.07 0-.14-.07-.21.35-.07 3.76-.71 9.72-.71 7.95 0 20.44 1.21 36.19 6.53-23.85-27.4-38.61-45.92-40.31-48.12.21-.28.43-.57.64-.78l.78-.57c.43.57 15.54 19.8 40.81 48.75-.85-26.12 14.19-53.3 15.54-55.57.28.14.64.21.92.35l.85.5c-.14.28-17.17 29.88-15.19 57.06 17.74 20.22 40.17 44.99 65.93 71.32-3.76-12.85-1.92-28.81 1.63-43.5.5.85.99 1.77 1.49 2.62-3.55 15.4-4.97 31.86.07 44.14 19.87 20.23 41.66 41.37 64.65 62.1a95.67 95.67 0 0 1-3.41-16.18c.78.92 1.56 1.92 2.34 2.84.85 5.25 2.13 10.65 3.97 15.97 18.1 16.18 36.91 32.08 56.14 47.12-.49-1.06-.92-2.06-1.28-3.12 1.07.92 2.13 1.77 3.19 2.7.5 1.06 1.07 2.2 1.63 3.19a837.555 837.555 0 0 0 32.29 23.77v2.41z",
    className: "fil6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 861.55c-11.71-8.44-25.19-17.1-38.89-23.77 15.47 6.6 36.12 21.72 38.89 23.77z",
    style: {
      fill: "#aac0ce",
      fillRule: "nonzero"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M292.67 1098.95c-11.43-7.24-22.43-15.26-32.93-23.85-4.75-10.43-6.46-22.78-6.67-34.28 6.03 7.73 12.14 15.54 18.31 23.28 4.75 5.96 13.41 14.62 22 23.78l-.78 11.14.07-.07zm-36.12-26.54c-21.65-18.17-41.3-38.68-58.76-59.97-2.41-15.76-.71-31.01 2.13-43.57 16.54 23.56 33.57 46.63 51.24 69.41 0 11.21 1.28 23.42 5.39 34.14zm-61.17-62.81c-24.84-30.52-45.35-62.24-61.25-89.99 3.12-13.63 7.95-26.47 11.49-34.85a908.74 908.74 0 0 0 22.43 36.76c8.8 13.63 17.74 27.04 26.9 40.31l-.28 1.42c.5.14.99.21 1.49.35.71 1.07 1.49 2.13 2.2 3.19-2.98 12.28-4.9 27.25-2.98 42.87v-.07zm-62.74-92.61c-25.69-45.21-39.03-79.27-39.03-79.27h.07c13.7 6.67 27.18 15.33 38.89 23.77.21.14.28.21.28.21 3.76 7.03 7.66 13.98 11.57 20.79-3.4 8.02-8.37 20.65-11.71 34.42l-.07.07z",
    className: "fil8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M259.74 1075.1c-1.06-.85-2.13-1.77-3.19-2.7-4.12-10.72-5.39-22.92-5.39-34.14.64.85 1.28 1.7 1.92 2.48.21 11.5 1.92 23.85 6.67 34.28v.07zm-62.02-62.6c-.78-.92-1.56-1.92-2.34-2.84-1.92-15.61.07-30.59 2.98-42.87.5.71.99 1.42 1.49 2.13-2.91 12.56-4.61 27.82-2.13 43.57zm-63.59-92.9c-.5-.85-.99-1.77-1.49-2.63 3.34-13.77 8.3-26.47 11.71-34.42.43.71.85 1.42 1.28 2.2-3.48 8.37-8.3 21.22-11.5 34.85z",
    className: "fil9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M318.79 1121.94c-3.48-14.83-36.12-43.79-47.33-57.91-36.91-46.27-71.25-92.69-103.33-142.51-51.52-80.2-104.39-189.13-100.99-286.85 1.28-36.12 14.9-97.09 60.04-100 33.78-2.2 60.75 34.49 76.65 60.11 41.87 67.35 62.02 146.19 79.63 222.7 20.23 87.93 32.29 178.41 44.85 268.05l-9.51 36.34v.07z",
    className: "fil4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.16 963.54c-.5-.14-.99-.21-1.49-.35l.28-1.42c.43.57.78 1.13 1.21 1.77z",
    className: "fil10"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.15 858.72c-.35-.07-.71-.07-.99-.14l.21-1.42c.29.49.57 1.06.85 1.56h-.07zM79.63 732.25c-.21 0-.43-.07-.64-.07l.21-1.42c.14.5.29.99.43 1.49z",
    className: "fil5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.88 639.35c-.21-.5-.5-.99-.71-1.49l1.14.85s-.21.21-.43.64zM68.2 619.98h-.07l.21-1.28c-.07.43-.07.85-.14 1.28zm104.96-64.87c-.35-.35-.71-.64-1.06-.99l1.14.92s0 .07-.07.07zm-60.25-17.39c0-.14-.07-.21-.07-.21l1.35-.28c-.43.14-.85.35-1.28.5z",
    className: "fil11"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M293.67 1049.76c-8.16-17.39-15.97-34.49-23.42-51.24-4.12-6.74-19.37-22.57-74.02-34.99-.43-.57-.78-1.14-1.21-1.77l.28-1.42c41.73 9.3 61.53 20.65 70.9 29.03-13.13-29.67-25.27-58.34-36.41-85.8v-.07c-.28-.35-28.03-34.99-98.58-44.85-.28-.5-.57-1.06-.85-1.56l.21-1.42c55.43 7.52 85.23 30.23 96.31 40.66A2811.964 2811.964 0 0 1 186 788.6l-.14-.21c-.35-.43-32.86-44.78-106.24-56.14-.14-.5-.28-.99-.43-1.49l.21-1.42c58.91 8.94 92.05 38.89 103.83 51.6-14.62-41.66-26.61-78.85-36.19-110.92-1.35-1.28-45.21-44.36-78.92-49.96.07-.43.07-.85.14-1.28l.29-1.56c29.52 4.9 65.22 36.33 76.79 47.19-22.78-76.86-31.79-122.78-32.57-126.54.43-.14.85-.35 1.28-.5l1.49-.29c.21.99 8.52 44.43 30.37 119.23-2.06-68.56 24.63-102.62 24.91-102.98l1.14.92c.35.35.71.64 1.07.99-1.63 2.13-29.17 39.39-23.56 112.98 9.65 32.22 21.65 69.69 36.41 111.7 5.04-94.32 39.67-142.29 40.03-142.79l1.21.85c.21.5.5.99.71 1.49-4.19 6.11-36.05 55.57-39.39 147.69 11.99 33.78 25.76 70.33 41.45 109.29 1.77-20.15 4.19-37.75 6.95-53.01.85.5 1.77.92 2.77 1.13-2.98 16.54-5.61 35.7-7.38 57.84 11.92 29.45 25.05 60.32 39.32 92.33 0-14.55.78-28.1 2.06-40.59.92.14 1.92.35 2.84.43-1.42 14.19-2.27 29.88-1.92 46.77 6.17 13.7 12.49 27.61 19.09 41.73v6.81l.07-.15zm-46.77-248.6c.21-.71.43-1.42.64-2.06-.07.71-.14 1.35-.21 2.06h-.42z",
    className: "fil6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M754.89 1029.04c-6.25-21.79-8.16-53.23-10.72-79.77-5.39-55.14-4.47-112.13 2.2-167.13 4.83-39.46 17.81-84.81 42.58-116.81 11.92-15.4 34.14-35.49 55.43-32.86 51.74 6.46 38.82 113.83 31.3 146.05-20.3 87.43-65.15 179.05-120.79 250.45v.07z",
    className: "fil4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M880.15 678.03c0-.07-.07-.14-.07-.21h.07v.21zM804 649.29l.14-.07c-.07 0-.07.07-.14.07zm40.38-16.82c-.35-.07-.64-.07-.99-.14.07-.14.07-.21.07-.21l.92.35z",
    className: "fil11"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M774.62 883.41v-2.91c3.19-3.48 6.6-6.67 10.15-9.51-.28 1.06-.57 2.13-.78 3.19-3.26 2.77-6.39 5.89-9.37 9.3v-.07zm0-3.97v-9.8c5.46-26.47 11.64-52.09 17.95-76.15v-.14c-3.55-32.15-11.71-57.48-17.95-73.1v-5.11c6.17 14.48 15.12 39.96 19.3 73.17 9.44-35.49 19.16-67.35 27.47-92.9-5.68-30.3-18.59-44.78-18.74-44.92l1.35-1.21c.07 0 .07-.07.14-.07.57.64 12.49 13.91 18.52 42.44 11.28-34.49 19.73-56.63 20.72-59.26.35 0 .64.07.99.14l.92.35c-.29.71-9.02 23.49-21.01 60.04 10.86-6.95 23.91-10.72 34.7-12.7-.43.71-.85 1.49-1.21 2.2-10.93 2.2-23.99 6.17-34.42 13.48-8.3 25.55-18.1 57.56-27.54 93.18 4.97-5.32 11.57-9.72 18.95-13.34-.35.92-.71 1.84-1.07 2.77-7.73 4.05-14.48 8.94-19.02 14.98-7.1 27.04-13.98 56.06-20.01 85.94h-.07z",
    className: "fil6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M881.5 688.04c-.35-3.12-.78-6.25-1.35-9.23v-.78c.71 2.84 1.35 5.89 1.99 9.01-.21.29-.43.64-.64.99zm-1.56-10.22c-.14-.71-.29-1.42-.43-2.13.21.71.35 1.42.57 2.13h-.14z",
    style: {
      fill: "#ccd7db",
      fillRule: "nonzero"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M774.62 994.91V945.8c3.83-3.34 7.95-6.39 12.21-9.15a1060.13 1060.13 0 0 0-11.5 54.72c-.21 1.21-.43 2.34-.64 3.55h-.07zm0-51.67V916.7c1.99-10.57 5.04-25.12 9.37-42.58 7.66-6.6 16.11-11.64 24.41-15.54-5.39 17.24-10.43 34.56-15.05 52.02l-1.42.29c0 .07.21 1.06.5 3.12-1.7 6.6-3.41 13.27-4.97 19.87-4.4 2.77-8.73 5.89-12.85 9.3v.07zm10.15-72.31c6.53-25.98 15.9-57.91 28.88-92.4 8.44-4.4 18.1-7.66 27.32-10.15-1.35 3.34-2.7 6.67-4.05 10.08l-1.35.43c0 .07.21.64.49 1.77-9.79 24.77-18.73 49.96-26.82 75.51-8.23 3.69-16.61 8.52-24.41 14.83l-.07-.07zm29.95-95.24c11.43-30.02 25.62-61.88 43.08-93.32 12.49-2.48 22.21-2.63 22.43-2.63v-.99c.57 2.98.99 6.1 1.35 9.22-13.91 21.79-25.62 44.78-34.99 66.85-1.56 3.69-3.12 7.38-4.61 11.07-9.08 2.34-18.66 5.53-27.18 9.72l-.07.07zm44.28-95.6c4.54-8.09 9.3-16.18 14.34-24.2 0 0 3.19 7.88 6.25 19.73.14.71.28 1.42.43 2.13-1.35 0-9.94.28-21.01 2.41v-.07z",
    className: "fil8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M880.15 678.74c-.07-.35-.14-.64-.14-.99h.14c0 .07.07.14.07.21v.78h-.07z",
    style: {
      fill: "#bed0d7",
      fillRule: "nonzero"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M774.62 945.79v-2.56c4.04-3.4 8.44-6.53 12.85-9.3-.21.92-.43 1.77-.64 2.7-4.19 2.77-8.37 5.75-12.21 9.15zm9.37-71.68c.28-1.07.5-2.13.78-3.19 7.81-6.32 16.18-11.14 24.41-14.83-.28.85-.49 1.63-.78 2.48-8.3 3.9-16.68 8.94-24.41 15.54zm29.66-95.59c.35-.92.71-1.84 1.07-2.77 8.59-4.26 18.17-7.38 27.18-9.72-.35.78-.64 1.56-.99 2.41-9.23 2.48-18.88 5.75-27.32 10.15l.07-.07zm44.14-96.16c.43-.71.85-1.49 1.21-2.2 11.07-2.06 19.66-2.34 21.01-2.41.07.35.14.64.14.99v.99c-.21 0-9.94.14-22.43 2.63h.07z",
    className: "fil9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M758.01 1109.02c0-33.5 10.15-78.85 17.25-117.59 14.76-80.55 39.32-161.03 71.25-236.47 22.92-54.08 59.9-113.12 108.09-148.47 23.21-16.96 62.95-36.48 92.04-24.06 70.83 30.31 8.66 177.49-15.04 220.21-64.44 115.89-165.57 227.67-273.59 306.44v-.07z",
    className: "fil4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M901.02 980.92c.43-.5.92-.99 1.35-1.49v1.42h-1.42l.07.07zm75.01-90.49s-.21-.07-.57-.14c.29-.43.64-.85.92-1.28l-.35 1.42zm67.42-110.57s-.14 0-.35-.07c.21-.43.43-.92.64-1.35l-.28 1.42z",
    style: {
      fill: "#c7e1ee",
      fillRule: "nonzero"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.65 662.63c.07-.5.07-.99.14-1.42.14.07.21.07.21.07l-.35 1.35z",
    className: "fil15"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M907.83 651.49c-.14-.64-.21-.99-.21-1.06l1.42-.35c-.35.49-.78.92-1.14 1.42h-.07zm74.52-61.67.35-.21c-.14.07-.21.14-.35.14v.07z",
    className: "fil11"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.71 582.37c-.43-.21-.92-.35-1.42-.57.14-.14.21-.28.21-.28l1.14.85h.07z",
    className: "fil15"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M792.44 914.07c-.29-2.06-.5-3.05-.5-3.12l1.42-.28c-.28 1.14-.57 2.27-.92 3.41zm43.58-133.42c-.29-1.14-.5-1.7-.5-1.77l1.35-.43c-.28.71-.57 1.42-.85 2.2z",
    className: "fil10"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M774.62 1065.66v-8.16c5.46-14.34 11.21-28.67 17.25-42.94 5.39-58.91 1.91-90.91.57-100.49.28-1.14.57-2.27.92-3.41l1.42-.28c.07.28 6.11 30.09.78 95.74 13.98-32.36 29.24-64.44 45.14-95.59v-.07c7.81-77.57-2.27-120.93-4.69-129.87.28-.71.57-1.42.85-2.2l1.42-.43c.14.43 13.34 42.58 5.96 125.69 20.65-39.96 42.23-78.35 63.3-113.83v-.21c12.92-74.87 2.06-129.94.28-138.18.35-.5.78-.92 1.14-1.42l1.42-.35c.14.57 13.27 55.64 1.14 133.35 27.89-46.63 54.72-87.86 76.86-120.79 4.33-45.42-8.16-71.11-8.3-71.39l2.2-1.14c.14-.07.21-.14.35-.14.57 1.14 11.99 24.91 9.01 67.84 30.16-44.42 51.1-72.39 53.58-75.72.5.21.92.35 1.42.57l1.14.85c-.64.85-22.43 29.66-54.29 76.72 11.99-3.55 24.69-4.82 36.62-4.82 24.91 0 46.06 5.39 48.62 6.03-.07.5-.07.99-.14 1.42l-.35 1.42c-.35-.07-22.21-6.03-48.05-6.03-12.77 0-26.61 1.42-39.25 5.82-22.21 32.93-49.11 74.38-77.07 121.07 18.17-10.86 43.79-14.05 67.56-14.05 31.94 0 60.47 5.75 62.6 6.17l-.29 1.42c-.21.43-.43.92-.64 1.35-3.34-.64-31.01-5.89-61.74-5.89-25.69 0-53.51 3.69-70.9 16.82-21.43 35.98-43.36 75.08-64.37 115.75 29.66-18.38 63.09-22.85 88.78-22.85 24.27 0 41.52 4.05 41.87 4.12l-.35 1.42c-.28.43-.64.85-.92 1.28-3.19-.71-19.16-3.9-40.66-3.9-26.4 0-61.25 4.83-91.34 25.12-16.32 31.94-31.94 64.79-46.2 97.94 37.54-30.3 104.47-31.51 105.1-31.51v1.42c-.43.5-.92.99-1.35 1.49-10.15.35-73.59 3.76-106.38 34.63-7.1 16.68-13.77 33.43-20.01 50.1v.15z",
    className: "fil6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M774.62 1132.8c0 7.59-6.17 13.77-13.77 13.77H307.5c-7.59 0-13.77-6.17-13.77-13.77V163.23c0-7.59 6.17-13.77 13.77-13.77h453.35c7.59 0 13.77 6.17 13.77 13.77v969.57z",
    className: "fil16"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M302.82 1030.11H765.4V212.19H302.82zM564.77 1087.31c0 16.89-13.7 30.66-30.66 30.66-16.89 0-30.66-13.7-30.66-30.66 0-16.89 13.7-30.66 30.66-30.66 16.89 0 30.66 13.7 30.66 30.66z",
    className: "fil17"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M534.11 1095.47c-11.71 0-23.35-3.19-23.35-9.65 0-12.91 10.43-23.35 23.35-23.35 12.92 0 23.35 10.43 23.35 23.35 0 6.46-11.71 9.65-23.35 9.65z",
    style: {
      fill: "#adcfde",
      fillRule: "nonzero"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M374.22 790.16h-70.33c10.79-48.83 29.88-110.78 30.94-154.43 30.02-43.86 41.8-76.57 46.41-94.74 2.27 70.97 6.95 133.42 2.7 186.01-2.48 30.87-6.46 48.4-9.72 63.16z",
    className: "fil11"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M742.83 212.19H302.82v-47.12H765.4z",
    className: "fil19"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M302.82 488.83V212.2h439.93L686.9 328.59c-24.63-14.69-72.03-36.2-138.6-36.2-101.27 0-157.76 41.87-157.76 41.87s-7.31 53.16-9.65 110.57l-66 6.6s-5.18 15.12-11.99 37.33l-.07.07z",
    className: "fil11"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M302.82 1128.54v-98.43h47.27z",
    className: "fil19"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M524.88 976.59c1.56 14.83 3.98 33.22 6.89 53.58h175.15c-2.13-61.88-5.11-126.25-8.73-197.51 0 0-178.56-.43-329.23-.43-4.4 66.78-7.31 131.36-8.52 197.93h156.91l7.52-53.58z",
    className: "fil20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M380.11 479.74c.14 96.59 9.3 180.05 3.83 247.25-4.83 59.26-15.04 69.48-14.98 105.25 0 17.03 319.78 31.3 329.23.43.57-38.75-14.69-94.03-14.12-153.44.64-62.17 5.89-124.83 1.35-168.05l20.94-169.12s-56.85-49.68-158.05-49.68c-101.27 0-157.76 41.87-157.76 41.87s-10.5 76.72-10.43 145.48z",
    className: "fil3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M436.39 142.57c2.06 15.19 13.77 34.63 25.05 28.74 9.08-4.75 16.68-12.63 14.69-27.75-1.99-15.19-9.94-22.64-22-25.05-12.99-2.62-19.73 8.87-17.74 24.06z",
    className: "fil21"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M439.94 123.48c2.41-2.98 15.4-4.61 19.16 6.74l-1.42-10.72s-4.19-1.99-9.15-1.21c-6.46 1.07-8.66 5.18-8.66 5.18h.07z",
    className: "fil22"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M632.05 142.57c-1.99 15.19-13.77 34.63-25.05 28.74-9.08-4.75-16.68-12.63-14.69-27.75 2.06-15.19 9.94-22.64 22-25.05 12.99-2.62 19.73 8.87 17.74 24.06z",
    className: "fil21"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M628.5 123.48c-2.41-2.98-15.47-4.61-19.23 6.74l1.42-10.72s4.19-1.99 9.15-1.21c6.46 1.07 8.66 5.18 8.66 5.18zM587.48 215.17c-4.75 16.61.71 63.09 1.84 72.39 5.53.71 25.34 11.64 31.09 13.7-2.7 16.68-25.48 61.39-80.62 61.39s-88.43-40.59-91.98-55.21c11.64-4.61 25.12-18.67 32.36-19.73 0 0 8.94-45.49 3.12-72.74l104.25.14-.07.07z",
    className: "fil22"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M587.12 216.67s-2.2 12.07-1.49 22.14c0 0-29.88 32.22-51.17 32.22-21.29 0-49.25-29.74-49.25-29.74s.21-18.81-2.2-27.68l104.11 3.05z",
    className: "fil21"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M457.75 111.06c0 42.23 34.21 76.43 76.43 76.43 42.23 0 76.43-34.21 76.43-76.43 0-56.7-34.21-83.96-76.43-83.96-42.23 0-76.43 28.46-76.43 83.96z",
    className: "fil22"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M457.75 111.06c0 40.88 0 75.08 15.61 97.37 9.37 13.41 33.78 36.41 51.45 42.23 4.4 1.42 16.96.71 21.29-.85 17.53-6.17 39.96-28.6 48.97-41.37 15.61-22.21 15.61-56.42 15.61-97.37H457.75z",
    className: "fil22"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M487.77 138.67c0 6.96 4.19 12.56 9.37 12.56 5.18 0 9.37-5.68 9.37-12.56 0-6.95-4.19-12.56-9.37-12.56-5.18 0-9.37 5.61-9.37 12.56zM560.08 138.67c0 6.96 4.19 12.56 9.37 12.56 5.18 0 9.37-5.68 9.37-12.56 0-6.95-4.19-12.56-9.37-12.56-5.18 0-9.37 5.61-9.37 12.56zM509.34 109.64s-.5.07-1.35.14c-.85 0-2.06.21-3.55.28-1.49.14-3.12.28-4.97.5-1.77.28-3.76.35-5.68.71-1.92.29-3.83.5-5.61.85-1.77.35-3.48.5-4.9.85-2.84.57-4.83.85-4.83.85h-.07c-.43.07-.85-.28-.92-.71-.07-.35.14-.64.43-.85 0 0 1.77-.92 4.61-2.13 1.42-.64 3.12-.99 4.97-1.49 1.84-.57 3.83-.78 5.89-1.07 1.99-.28 4.05-.35 5.89-.43 1.92 0 3.69 0 5.18.21 1.49.14 2.77.35 3.62.49.92.14 1.35.29 1.35.29.43.14.71.57.57.99-.07.35-.35.57-.71.57l.07-.07zM560.01 108.01s.5-.14 1.35-.28c.85-.14 2.13-.29 3.62-.43 1.49-.14 3.26-.14 5.18-.14 1.92.14 3.9.14 5.89.43 1.99.28 4.05.5 5.82 1.06 1.84.5 3.55.85 4.97 1.49 2.84 1.14 4.61 2.06 4.61 2.06.43.21.57.71.35 1.06-.14.29-.49.5-.85.43h-.07s-1.99-.29-4.82-.92c-1.42-.35-3.12-.49-4.9-.85-1.77-.35-3.69-.57-5.61-.85-1.92-.28-3.83-.43-5.68-.71-1.84-.14-3.55-.35-4.97-.43-1.49-.14-2.7-.21-3.55-.29-.85-.07-1.35-.07-1.35-.07-.43 0-.78-.43-.78-.85 0-.35.28-.64.57-.71h.21z",
    className: "fil16"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M547.59 179.19c-4.9-2.34-22.5-2.48-26.68 0-4.19 2.48 8.8 5.82 13.34 5.82 4.54 0 17.25-3.69 13.34-5.82z",
    className: "fil21"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M564.56 196.86c-15.9 5.89-41.45 8.16-56.78 8.09-1.92 0-2.63.43-.07 1.14 4.47 1.35 18.88 15.9 30.23 14.62 11.36-1.28 23.85-20.22 27.32-22.99 1.49-1.14.71-1.42-.71-.92v.07z",
    className: "fil2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M515.37 669.66c-10.01 15.97-35.49 18.1-56.78 4.75-21.29-13.41-30.44-37.19-20.37-53.23 10.08-15.97 35.49-18.1 56.78-4.69s30.45 37.19 20.37 53.16z",
    className: "fil23"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m438.23 621.19 15.33-24.92 76.01 49.11-15.97 26.69-59.19-19.09z",
    className: "fil23"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M528.93 646.45c-10.01 15.97-35.34 18.17-56.56 4.9-21.22-13.34-30.23-37.05-20.16-53.09 10.08-15.97 35.34-18.17 56.56-4.9 21.15 13.34 30.23 37.05 20.16 53.01v.07z",
    className: "fil17"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M542.34 564.98s-28.32-11.57-26.76-33.64c.85-12.28 11.43 1.14 22.85 8.59 16.82 11.07 27.46 16.04 39.53 44.57l-25.48-.14-10.08-19.44-.07.07z",
    className: "fil22"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m571.23 526.73-24.91-16.25-65.36 100.35h.07a14.583 14.583 0 0 0-2.48 8.16c0 8.23 6.67 14.9 14.9 14.9 5.47 0 10.22-2.98 12.85-7.45l65.01-99.78-.07.07z",
    className: "fil20"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M578.11 584.35c4.97 3.98 61.88 31.3 61.88 31.3 22 11.07 78.77 31.09 78.77 31.09s-42.3-91.27-42.3-139.03c0-34.56 93.32-32.5 93.32-32.5s34.99 184.45 36.91 224.47c.85 17.17-21.86 53.44-39.18 51.52-61.32-6.96-211.48-116.82-221.21-121.14-4.47-1.99-58.41-.07-65.86-28.32-10.65-19.23 26.97-61.53 40.52-52.87-2.98 4.19-4.4 13.91 3.34 19.02 7.88 5.18 17.1 4.12 20.94-1.7l33 18.31-.14-.15z",
    className: "fil22"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M586.63 554.97c-10.01 15.97-35.49 18.1-56.78 4.75-21.29-13.41-30.44-37.19-20.37-53.16 10.08-15.97 35.49-18.1 56.78-4.75 21.29 13.41 30.45 37.19 20.37 53.23v-.07z",
    className: "fil23"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m509.41 506.5 15.4-24.84 76.01 49.11-15.97 26.68-59.26-19.08z",
    className: "fil23"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M600.18 531.76c-10.01 15.97-35.34 18.17-56.56 4.9-21.22-13.34-30.23-37.05-20.16-53.08 10.08-15.97 35.34-18.17 56.56-4.9 21.15 13.27 30.23 37.05 20.16 53.01v.07z",
    className: "fil17"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M696.56 592.37c-6.39-18.45-4.83-44 9.58-44.85 14.41-.85 55.21-5.96 70.12-39.1l-2.13-8.09-96.02 26.04s7.59 47.12 18.45 66z",
    className: "fil21"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M706.35 342.07c25.83 26.68 56.42 70.97 69.12 150.95.21 30.09-79.34 47.33-97.44 33.43-6.67-25.98-20.3-107.38-20.3-107.38l48.61-77z",
    className: "fil24"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M481.8 580.23c-1.28 11.07 8.52 27.61 24.2 30.16 0 0-10.65-5.61-17.1-14.05-6.46-8.44-7.1-16.11-7.1-16.11zM488.55 568.74c-1.28 11.07 8.52 27.61 24.2 30.16 0 0-10.65-5.61-17.1-14.05-6.46-8.44-7.1-16.11-7.1-16.11zM274.22 918.05c-5.11 9.86-1.84 28.81 11.99 36.76 0 0-7.95-9.01-11-19.16s-.92-17.6-.92-17.6h-.07zM259.67 919.96c-5.11 9.86.78 26.11 14.55 34.06 0 0-9.08-6.39-12.14-16.61-3.05-10.15-2.48-17.46-2.48-17.46h.07zM249.24 922.45c-.71 7.45-.43 20.08 13.13 28.39 0 0-7.52-4.83-10.22-15.12-2.77-10.22-2.84-13.27-2.84-13.27h-.07zM497.77 558.38c-1.28 11.07 8.52 27.61 24.2 30.16 0 0-10.65-5.61-17.1-14.05-6.46-8.44-7.1-16.11-7.1-16.11z",
    className: "fil21"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m584.64 508.7-29.31-25.62-14.05 16.11 29.31 25.55z",
    className: "fil17"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m570.59 524.74 14.05-16.11-5.11-4.47-4.26 4.9-24.2-21.15-3.55 4.12c-.28 2.84-1.07 5.32-2.84 8.44l3.9 3.41 4.19-4.75 17.67 15.47-4.97 5.68 5.11 4.47z",
    style: {
      fill: "#acd6e9",
      fillRule: "nonzero"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M610.97 143.28s5.53 6.18 4.68 9.58c-.85 3.41-6.6 8.09-6.6 8.09l1.92-17.6v-.07zM457.89 143.28s-5.53 6.18-4.69 9.58c.85 3.41 6.6 8.09 6.6 8.09l-1.92-17.6v-.07z",
    className: "fil22"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M534.18 59.61c10.86 0 20.01-4.61 31.51-7.45 20.51-5.11 30.37 16.96 30.37 16.96 11.78 19.3 9.23 79.84 9.37 83.32.14 3.48 4.83 3.98 4.97 0 0 0 8.02-45.92 7.24-70.47-.99-32.5-12.21-73.1-54.01-64.37-31.79-35.77-78.56-3.69-109.15-16.82-1.63-.71-3.62 1.42-2.98 3.34 8.52 26.47 10.15 39.1 4.75 73.6-4.9 31.37 1.7 65.65 1.7 73.66 0 4.61 5.11 3.98 5.11-.14 0-6.46-1.92-69.91 10.15-87.93 14.62-21.72 50.46-3.76 61.03-3.76l-.07.07z",
    className: "fil16"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m684.42 841.83 8.59 188.28h2.77l-8.66-188.43zM675.19 843.32l8.45 186.79h2.7l-8.38-186.86zM379.61 838.42l-9.51 191.69h2.77l9.51-191.55zM388.2 839.77l-8.73 190.34h2.77l8.73-190.2z",
    className: "fil2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M765.4 1030.11h-58.55c-.5-14.05-.99-28.18-1.56-42.51h5.75v-2.77h-5.89c-1.92-48.05-4.26-98.15-7.03-152.16.21-12.56-1.28-26.9-3.41-42.51h70.69v239.95z",
    style: {
      fill: "url(#id18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.77 1030.11h-14.4l5.96-42.51h2.77c1.49 12.56 3.4 26.97 5.68 42.51zm-5.96-45.28h-2.06l1.14-8.23c.28 2.63.57 5.39.92 8.23z",
    style: {
      fill: "url(#id3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.38 1030.11h-10.29l10.79-22.43c-.21 7.45-.35 14.9-.5 22.43z",
    style: {
      fill: "url(#id10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.82 1030.11h-.5v-83.53c.14.14.35.29.5.43v83.1z",
    style: {
      fill: "url(#id13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.82 858.01c-.14-.21-.35-.5-.5-.71v-60.11c.14-.78.35-1.63.5-2.41v63.23z",
    style: {
      fill: "url(#id14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.09 1030.11h-47.27v-83.1c.99.78 2.06 1.49 3.26 2.06 1.56.78 2.77 1.13 3.69 1.13 5.68 0 1.21-13.41.78-25.19-.64-18.31 7.95-43.79-7.73-67.14v-63.23c.28-1.49.64-2.98.99-4.54h70.33c-2.98 13.63-5.32 24.91-5.25 42.01l-1.56 12.07c.21.35.5.64.71.99-2.98 47.05-5.18 93.04-6.6 139.67h-23.13v2.77h23.07c-.21 6.67-.35 13.41-.57 20.15l-10.79 22.43.07-.07z",
    style: {
      fill: "url(#id25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.92 1030.11h-11.07l-1.92-42.51h11.43c.57 14.34 1.14 28.53 1.56 42.51zm-13.84 0h-6.67l-1.92-42.51h6.6l1.92 42.51h.07zm-9.44 0H531.77c-2.27-15.61-4.19-30.02-5.68-42.51h155.63l1.92 42.51zm-166.28 0H382.24l1.99-42.51H523.4l-5.96 42.51h-.07zm-137.89 0h-6.6L375 987.6h6.46l-1.99 42.51zm-9.37 0h-9.72c.14-7.52.29-14.98.5-22.43.14-6.74.35-13.41.57-20.15h10.86l-2.13 42.51-.07.07zm335.04-45.28h-11.5l-5.89-129.02c4.61-2.56 8.3-5.32 10.86-8.38l-.57-14.76c2.77 54.01 5.11 104.11 7.03 152.16h.07zm-14.19 0h-6.6l-5.61-124.76c2.27-.92 4.4-1.92 6.39-2.91l5.82 127.67zm-9.37 0H525.8c-.35-2.84-.64-5.61-.92-8.23l-1.13 8.23H384.37l3.27-71.61c1.92 13.7 13.63 24.27 27.89 24.27 15.54 0 28.1-12.56 28.1-28.1 0-15.54-12.56-28.1-28.1-28.1-13.34 0-24.49 9.23-27.4 21.72l1.99-43.93c23.77 9.65 60.25 16.18 91.76 19.52-6.25 8.66-9.86 19.3-9.86 30.8 0 29.17 23.63 52.8 52.8 52.8 29.17 0 52.8-23.63 52.8-52.8 0-11.07-3.41-21.36-9.23-29.81 36.19-2.41 80.05-7.88 107.73-18.38l5.53 123.7-.07-.07zm-47.41-103.54c-15.54 0-28.1 12.56-28.1 28.1 0 15.54 12.56 28.1 28.1 28.1 15.54 0 28.1-12.56 28.1-28.1 0-15.54-12.56-28.1-28.1-28.1zM381.59 984.83h-6.46l6.39-129.66c1.84.92 3.76 1.84 5.82 2.77l-5.82 126.89h.07zm-9.16 0h-10.86c1.42-46.56 3.62-92.62 6.6-139.67 2.41 3.05 6.1 5.82 10.79 8.52l-6.46 131.15h-.07z",
    style: {
      fill: "url(#id4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.04 845.23c-.29-.35-.5-.64-.71-.99l1.56-12.07c-.28 4.33-.57 8.66-.85 12.99v.07z",
    style: {
      fill: "url(#id23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.31 879.51c-9.51-13.84-25.48-22.92-43.57-22.92-17.67 0-33.28 8.66-42.87 22-31.51-3.34-67.99-9.94-91.76-19.52l.85-19.09c35.55 6.17 108.3 10.79 174.09 10.79 44.42 0 85.66-2.06 110.14-7.17l.78 17.53c-27.61 10.5-71.54 15.97-107.73 18.38h.07zm110.43-19.45-.78-16.89-1.14.07c12.21-2.7 19.94-6.17 21.29-10.57l.57 14.76c-2.62 3.05-6.31 5.82-10.86 8.37l-.64-14.12-2.77.14.71 15.4c-1.99.99-4.12 1.99-6.39 2.91v-.07zm-291.33-2.13c-2.06-.92-4.05-1.85-5.82-2.77l.85-16.61-2.77-.14-.78 15.26c-4.68-2.63-8.3-5.47-10.79-8.52.28-4.33.57-8.66.85-12.99 0 2.7 7.88 5.25 21.22 7.66l-1.92-.07-.85 18.17z",
    style: {
      fill: "url(#id5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.05 850.77c-65.79 0-138.53-4.61-174.09-10.79v-.14l-.85-.07c-13.34-2.34-21.22-4.97-21.22-7.66-.07-17.17 2.34-28.39 5.25-42.01H694.7c2.06 15.61 3.55 29.95 3.4 42.51-1.35 4.4-9.08 7.88-21.29 10.57l-1.63.07v.29c-24.48 5.11-65.79 7.17-110.14 7.17v.07zm-196.16-18.59zm329.22.43z",
    style: {
      fill: "#4a71f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.78 1030.11h-2.77l-1.92-42.51h2.77l1.92 42.51zm-2.06-45.28h-2.77l-5.82-127.67-.71-15.4 2.77-.14.64 14.12 5.89 129.02v.07z",
    style: {
      fill: "url(#id7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.34 1030.11h-2.77l-1.92-42.51h2.77l1.92 42.51zm-2.06-45.28h-2.77l-5.54-123.7-.78-17.53v-.29l1.63-.07 1.14-.07.78 16.89 5.61 124.76h-.07z",
    style: {
      fill: "url(#id11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.87 1030.11h-2.77l2.13-42.51H375l-2.13 42.51zm2.27-45.28h-2.77l6.46-131.15.78-15.26 2.77.14-.85 16.61-6.39 129.66z",
    style: {
      fill: "url(#id19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.24 1030.11h-2.77l1.99-42.51h2.77l-1.99 42.51zm2.06-45.28h-2.77l5.82-126.89.85-18.17 1.92.07.85.07v.14l-.85 19.09-1.99 43.93c-.49 2.06-.71 4.19-.71 6.46 0 1.35.07 2.62.28 3.9l-3.26 71.61-.14-.21z",
    style: {
      fill: "url(#id15)"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M297.57 851.19c22.78 25.05 12.35 53.79 13.06 73.88.5 13.7 6.46 29.66-4.47 23.99-19.66-10.15-12.7-43.72-12.7-43.72s-6.6 2.56-6.96 11.28c-.49 14.76 2.63 29.95 9.94 29.38.5 16.04-36.98 6.81-43.93-.64-16.54-17.46-13.34-71.96-12.7-76.79 1.28-10.57 4.4-40.52 4.4-40.52 5.68-49.96 23.07-193.39 33.07-241.93 12.63-61.53 37.68-134.77 37.68-134.77l74.73-7.52-5.47 80.76s-1.7 41.45-49.32 111c-1.63 66.35-44.99 175.15-37.26 215.46l-.07.15z",
    className: "fil22"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M242 849.13s4.26 1.7 8.52 0 10.57-6.1 11.78-10.29l34.14.92.43-3.41-37.19-3.62-8.09 6.6-9.23 5.18-.35 4.61z",
    className: "fil21"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m296.93 835.86-39.46-2.76 1.35-17.04 39.39 2.84z",
    className: "fil24"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M299.77 827.56c-.35 4.68-1.63 8.44-2.84 8.3-1.21-.07-1.92-3.97-1.49-8.66.35-4.69 1.63-8.44 2.84-8.3 1.21.07 1.92 3.98 1.49 8.66z",
    className: "fil24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m263.15 833.45-3.83-.29 3.83.29z",
    style: {
      fill: "#93605d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.92 816.49-3.97-.28z",
    style: {
      fill: "#986c6a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.15 833.45-3.83-.29c1.07-2.7 1.77-5.75 1.99-8.94.21-2.84.07-5.53-.43-8.02l3.98.28c.43 2.41.64 5.04.43 7.74a31.45 31.45 0 0 1-2.2 9.23h.07z",
    style: {
      fill: "#242c3d",
      fillRule: "nonzero"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M258.18 824.01c-.92 12.14-8.38 21.43-16.61 20.79-8.23-.64-14.19-11-13.27-23.06.92-12.14 8.37-21.44 16.61-20.8 8.23.64 14.19 10.93 13.27 23.07z",
    className: "fil24"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M261.38 824.3c-.92 12.14-8.38 21.43-16.61 20.8-8.23-.64-14.19-10.93-13.27-23.07.92-12.14 8.37-21.43 16.61-20.79 8.23.64 14.19 10.93 13.27 23.06z",
    className: "fil24"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M253.71 823.66c-.78 9.8-6.74 17.32-13.41 16.82s-11.5-8.87-10.72-18.67c.78-9.8 6.74-17.32 13.41-16.82s11.5 8.87 10.72 18.67z",
    className: "fil17"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M244.2 822.95c-.21 2.84-1.85 5.11-3.55 4.97-1.77-.14-2.98-2.56-2.77-5.39.21-2.84 1.77-5.11 3.55-4.97 1.7.14 2.98 2.56 2.77 5.46v-.07z",
    className: "fil24"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m241.72 822.45-4.47-10.5c-.14-.35-.57-.5-.92-.35-.35.14-.5.57-.35.92l4.47 10.5c.14.35.57.5.92.35.35-.14.5-.57.35-.92z",
    className: "fil24"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m240.8 823.3 6.46 2.91c.35.14.78 0 .92-.35s0-.78-.35-.92l-6.46-2.91c-.35-.14-.78 0-.92.35s0 .78.35.92z",
    className: "fil24"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M235.12 839.7s-4.97-4.9-5.96-10.72c-.99-5.82-.78-17.81 7.31-23.35 1.28-.92 2.56-1.49 3.69-1.85-1.06.85-2.06 1.77-2.98 2.98-4.05 2.7-7.03 8.37-7.59 15.12-.5 6.74 1.63 12.85 5.18 16.11.21.35.43.71.64 1.06l-.28.71v-.07z",
    className: "fil43"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M235.4 838.99c-.21-.35-.43-.71-.64-1.07.29.21.57.5.85.71l-.14.35h-.07zm13.7-30.87c-1.7-1.77-3.76-2.91-6.11-3.12h-.64c-1.84 0-3.62.64-5.25 1.7.92-1.14 1.92-2.13 2.98-2.98 1.06-.35 2.06-.49 2.98-.49 4.26 0 6.81 2.91 6.81 2.91l-.85 1.92.07.07z",
    className: "fil43"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M235.62 838.63c-.29-.21-.57-.43-.85-.71-3.55-3.27-5.68-9.37-5.18-16.11s3.55-12.42 7.59-15.12c1.63-1.07 3.41-1.7 5.25-1.7h.64c2.34.14 4.4 1.28 6.1 3.12l-5.25 11.85c-.49-1.42-1.35-2.34-2.41-2.41h-.14c-.5 0-.99.21-1.49.57l-2.63-6.17c-.14-.28-.35-.43-.64-.43-.07 0-.21 0-.29.07-.35.14-.5.57-.35.92l2.91 6.81c-.5.85-.85 1.99-.92 3.19-.21 2.7.85 5.04 2.48 5.39l-4.75 10.79-.07-.07z",
    className: "fil1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M240.37 827.84c-1.56-.35-2.63-2.7-2.48-5.39.07-1.21.43-2.34.92-3.19l1.56 3.69v.07c.07.07.14.14.21.14l1.35.57-1.77 3.9.21.21zm2.27-5.18-1.06-.5-1.77-4.12c.43-.35.92-.57 1.49-.57h.14c1.06.07 1.92 1.06 2.41 2.41l-1.21 2.7v.07z",
    className: "fil43"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M240.51 823.16zm0 0zm0 0zm0 0zm0 0zm0 0zm0 0zm0 0zm0 0zm0 0zm0 0zm0 0zm-.07-.07-1.56-3.69-2.91-6.81c-.14-.35 0-.78.35-.92.07 0 .21-.07.28-.07.28 0 .5.14.64.43l2.62 6.18 1.77 4.12-.28-.14c-.07-.07-.21-.07-.28-.07-.29 0-.5.14-.64.43a.8.8 0 0 0 0 .57z",
    className: "fil43"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m242.14 823.94-1.35-.57c-.07-.07-.14-.07-.21-.14v-.07c-.07-.14-.07-.35 0-.57.14-.29.35-.43.64-.43.07 0 .21 0 .29.07l.28.14 1.06.5-.57 1.28-.14-.21z",
    className: "fil43"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M364.14 584.92c7.24-13.63-41.66-18.24-54.79-37.83-13.2-19.52-11.92-39.1-11.92-39.1l80.26 45.07s-7.81 19.59-13.63 31.86h.07z",
    className: "fil21"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M390.54 334.26c-25.48 19.09-57.84 50.24-91.69 159.32-15.97 51.45 78.35 66.29 82.18 57.84 3.83-8.44 23.56-69.48 23.56-69.48l-14.05-147.76v.07z",
    className: "fil24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M524.74 962.19c-29.17 0-52.8-23.63-52.8-52.8 0-11.5 3.69-22.14 9.86-30.8 16.18 1.7 31.09 2.62 42.23 2.62 11.14 0 26.76-.5 44.21-1.63 5.82 8.52 9.23 18.73 9.23 29.81 0 29.17-23.63 52.8-52.8 52.8h.07z",
    style: {
      fill: "url(#id8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.1 881.21c-11.14 0-26.04-.85-42.23-2.62 9.58-13.34 25.19-22 42.87-22 18.1 0 34.07 9.08 43.57 22.92-17.46 1.21-33.07 1.63-44.21 1.63v.07z",
    style: {
      fill: "url(#id2)"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M528.08 888.81v41.09c0 2.27 1.85 4.12 4.12 4.12a4.12 4.12 0 0 0 4.12-4.12v-41.09c0-2.27-1.85-4.12-4.12-4.12a4.12 4.12 0 0 0-4.12 4.12zM513.17 888.81v41.09a4.12 4.12 0 0 0 8.24 0v-41.09a4.12 4.12 0 0 0-8.24 0z",
    className: "fil24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M634.17 937.49c-15.54 0-28.1-12.56-28.1-28.1 0-15.54 12.56-28.1 28.1-28.1 15.54 0 28.1 12.56 28.1 28.1 0 15.54-12.56 28.1-28.1 28.1z",
    style: {
      fill: "url(#id20)"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M640.42 919.47c-.5 0-.85-.35-.85-.85V900.1c0-.5.43-.85.85-.85.5 0 .85.35.85.85v18.52c0 .5-.35.85-.85.85z",
    className: "fil24"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m640.42 909.39-12.49 8.87v-17.82z",
    className: "fil24"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M628.78 902.15v14.48l10.15-7.24-10.15-7.24zm-.85 16.96-.43-.07a.885.885 0 0 1-.5-.78v-17.81c0-.35.21-.64.5-.78.28-.14.64-.14.92.07l12.49 8.87c.21.14.35.43.35.71 0 .28-.14.57-.35.71l-12.49 8.87-.5.14v.07z",
    className: "fil24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.45 937.49c-14.19 0-25.98-10.57-27.89-24.27l.5-10.29c2.91-12.42 14.05-21.72 27.4-21.72 15.54 0 28.1 12.56 28.1 28.1 0 15.54-12.56 28.1-28.1 28.1v.07z",
    style: {
      fill: "url(#id22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.56 913.29c-.14-1.28-.28-2.56-.28-3.9 0-2.2.28-4.33.71-6.46l-.5 10.29.07.07z",
    style: {
      fill: "url(#id17)"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M409.2 899.24c.5 0 .85.35.85.85v18.53c0 .5-.35.85-.85.85s-.85-.35-.85-.85v-18.53c0-.49.35-.85.85-.85z",
    className: "fil24"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m409.2 909.39 12.5-8.87v17.74z",
    className: "fil24"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M420.84 916.63v-14.48l-10.15 7.24 10.15 7.24zm.85-16.96.43.07c.28.14.5.43.5.78v17.81c0 .35-.21.64-.5.78-.28.14-.64.14-.92-.07l-12.49-8.94c-.21-.14-.35-.43-.35-.71 0-.28.14-.57.35-.71l12.49-8.87.5-.14z",
    className: "fil24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M711.03 987.59h-5.75c-.07-.92-.07-1.84-.14-2.77h5.89v2.77z",
    style: {
      fill: "url(#id21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.09 987.59h-2.77l.35-2.77h2.06c.07.92.21 1.84.28 2.77h.07z",
    style: {
      fill: "url(#id1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.37 987.59H338.3v-2.77h23.13c0 .92-.07 1.84-.07 2.77z",
    style: {
      fill: "url(#id6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.29 987.59h-11.43l-.14-2.77h11.5c0 .92.07 1.84.14 2.77h-.07zm-14.19 0h-6.6l-.14-2.77h6.6l.14 2.77zm-9.37 0H526.1c-.14-.92-.21-1.84-.28-2.77h155.77l.14 2.77zm-158.4 0H384.16l.14-2.77h139.38l-.35 2.77zm-141.94 0h-6.46l.14-2.77h6.46l-.14 2.77zm-9.23 0H361.3c0-.92.07-1.84.07-2.77h10.86l-.14 2.77h.07z",
    style: {
      fill: "url(#id0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.86 987.59h-2.77l-.14-2.76h2.77z",
    style: {
      fill: "url(#id24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.49 987.59h-2.77l-.14-2.76h2.77z",
    style: {
      fill: "url(#id12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 987.59h-2.77l.14-2.76h2.77z",
    style: {
      fill: "url(#id9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.15 987.59h-2.76l.14-2.76h2.77z",
    style: {
      fill: "url(#id16)"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M338.31 987.59h83.1v-2.76h-83.1z",
    className: "fil57"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M428.86 986.25c0 4.12-3.34 7.38-7.38 7.38-4.12 0-7.38-3.34-7.38-7.38 0-4.12 3.34-7.38 7.38-7.38 4.12 0 7.38 3.34 7.38 7.38z",
    className: "fil57"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M740.7 242.35h-11.28v-10.5h11.28v10.5zm5.47-15.76v20.94a.53.53 0 0 1-.5.35h-35.91c-.29 0-.5-.21-.5-.5v-5.25h-2.84c-.29 0-.5-.21-.5-.5v-9.08c0-.28.21-.5.5-.5h2.84v-5.25c0-.28.21-.5.5-.5h35.91c.21 0 .43.14.5.35v-.07zM688.68 230.08c2.13 0 3.83 1.7 3.83 3.83s-1.7 3.9-3.83 3.9-3.83-1.7-3.83-3.9c0-2.13 1.7-3.83 3.83-3.83zm6.95 7.31c.5-1.06.85-2.2.85-3.48 0-4.26-3.48-7.73-7.74-7.73s-7.73 3.48-7.73 7.73c0 1.28.35 2.41.85 3.48h-.07s.14.21.28.5l.28.5c1.42 2.34 4.9 8.02 5.47 8.87.71 1.14 1.21.85 1.7.07.35-.64 4.05-6.6 5.47-8.94l.28-.5c.21-.28.28-.5.28-.5h.07zM651.85 246.26h2.27v-8.45h-2.27z",
    className: "fil2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M654.12 237.81v-1.35h-2.27c-.35 0-.71.14-.99.43-.28.28-.43.64-.43.99v8.52c0 .35.14.71.43.99.28.28.64.43.99.43h2.27c.35 0 .71-.14.99-.43.29-.29.43-.64.43-.99v-8.52c0-.35-.14-.71-.43-.99-.28-.29-.64-.43-.99-.43v1.35h-1.35v7.1h-.92v1.35h1.35v-7.1h.92v-1.35h-1.35 1.35zM659.37 246.26h2.34v-14.2h-2.34z",
    className: "fil2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M661.71 232.06v-1.35h-2.27c-.35 0-.71.14-.99.43-.28.28-.43.64-.43.99v14.19c0 .35.14.71.43.99.29.29.64.43.99.43h2.27c.35 0 .71-.14.99-.43.28-.28.43-.64.43-.99v-14.19c0-.35-.14-.71-.43-.99s-.64-.43-.99-.43v1.35h-1.35v12.85h-.92v1.35h1.35v-12.85h.92v-1.35h-1.35 1.35zM667.1 246.26h2.28V226.6h-2.28z",
    className: "fil2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M669.38 226.6v-1.35h-2.27c-.35 0-.71.14-.99.43s-.43.64-.43.99v19.73c0 .35.14.71.43.99.28.28.64.43.99.43h2.27c.35 0 .71-.14.99-.43.29-.29.43-.64.43-.99v-19.73c0-.35-.14-.71-.43-.99-.28-.28-.64-.43-.99-.43v1.35h-1.35v18.31h-.92v1.35h1.35v-18.31h.92v-1.35h-1.35 1.35zM369.11 272.73c3.34-1.49 5.61-4.9 5.61-8.73 0-3.62-1.99-6.74-4.9-8.37-1.77-8.38-9.86-14.69-19.59-14.69-10.22 0-18.66 7.1-19.8 16.18-1.85 1.77-2.98 4.19-2.98 6.96 0 5.32 4.33 9.65 9.65 9.65.35 0 .71-.28.71-.71v-17.89c0-.35-.28-.71-.71-.71-.43 0-.92 0-1.35.07 2.13-5.25 7.81-9.01 14.48-9.01 6.67 0 12.35 3.76 14.48 9.01l-.28.57v17.88c0 .35.28.71.71.71h.64c.43 0 2.27-.43 3.34-.85v-.07z",
    className: "fil2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M350.44 124.55c-6.96 0-12.56-5.61-12.56-12.56s5.61-12.56 12.56-12.56S363 105.04 363 111.99c0 6.96-5.6 12.56-12.56 12.56zm-51.17 0c-6.95 0-12.56-5.61-12.56-12.56s5.68-12.56 12.56-12.56c6.96 0 12.56 5.61 12.56 12.56 0 6.96-5.61 12.56-12.56 12.56zm-51.1 0c-6.96 0-12.56-5.61-12.56-12.56s5.61-12.56 12.56-12.56 12.56 5.61 12.56 12.56c0 6.96-5.68 12.56-12.56 12.56zm101.77-82.89H248.17c-25.05 0-45.63 20.51-45.63 45.63v46.13c0 25.12 20.51 45.63 45.63 45.63h75.94l14.48 18.74c2.98 3.9 9.08 3.19 11.07-1.28l8.38-18.24c21.22-3.9 37.47-22.57 37.47-44.85V87.29c0-25.12-20.51-45.63-45.63-45.63h.07z",
    className: "fil3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHero);
export default __webpack_public_path__ + "static/media/home-hero.e1c31c0de60e40d10dcc2e9f108bad47.svg";
export { ForwardRef as ReactComponent };